import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, Consorcio, SearchConsorcioRequest, SaveConsorcioDto, MetodoRedondeoExpensa, ConceptosRecargo, ConsorcioMedioPagoDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})

export class ConsorcioService extends CrudService<Consorcio, number, SaveConsorcioDto, SearchConsorcioRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'consorcio', sharedFunctions);

  }

  getMediosPago(id: number): Observable<GenericResponse<ConsorcioMedioPagoDto[]>> {
    return this._http.get<GenericResponse<ConsorcioMedioPagoDto[]>>(this._serviceUrl + '/'+id+'/medios-pago', this.httpOptions);
  }

  getConceptosRecargo(): Observable<GenericResponse<ConceptosRecargo[]>> {
    return this._http.get<GenericResponse<ConceptosRecargo[]>>(this._serviceUrl + '/conceptos-recargo', this.httpOptions);
  }

  getMetodosRedondeoExpensa(): Observable<GenericResponse<MetodoRedondeoExpensa[]>> {
    return this._http.get<GenericResponse<MetodoRedondeoExpensa[]>>(this._serviceUrl + '/metodos-redondeo-expensa', this.httpOptions);
  }
}